import { useRef, useEffect, useCallback } from "react"
import { Wrapper, Hyper, Media } from "components"
import styles from "./styles.module.scss"
import type { FC } from "react"


export const Header: FC = () => {
  const hintRef = useRef<HTMLDivElement>(null)
  const buttonRef = useRef<HTMLButtonElement>(null)
  const scrollHandler = useCallback(() => {
    window.scrollTo({ top: buttonRef.current.offsetTop, behavior: 'smooth'})
  }, [])
  
  useEffect(() => {
    const handler = () => {
      const { scrollTop } = document.documentElement
      if (scrollTop > window.innerHeight * 1.5) return
      const height = (window.innerHeight - scrollTop) / 2
      hintRef.current.style.height = `${height}px`
      hintRef.current.style.opacity = scrollTop < window.innerHeight * .7 ? '1' : '0'
    }
    handler()
    window.addEventListener('scroll', handler, { passive: true })
    return () => window.removeEventListener('scroll', handler)
  }, [])

  return (
    <header className={styles.header} id="home">
      <Wrapper double className={styles.wrapper}>
        <div className={styles.limiter}>
          <h1>
            <span className={styles.mono}>
              Hi, my name is
            </span>
            <b itemProp="name">
              <span itemProp="givenName">Pavló </span>
              <span itemProp="familyName">Valor</span>
            </b><br />
            And I build things<br />
            for the web
          </h1>
          <p>
            I’m a <strong>software engineer</strong> from 
            <span itemProp="homeLocation"> Kyiv, Ukraine</span> specializing
            in building (and occasionally designing) web applications. 
          </p>
          <Hyper.Link type="bordered" href="#contact">
            <Media till="tablet">Reach me out</Media>
            <Media from="tablet">Do not hesitate to reach me out</Media>
          </Hyper.Link>
        </div>
      </Wrapper>
      <div className={styles.scrollHint} ref={hintRef}>
        <button ref={buttonRef} onClick={scrollHandler}>
          SCROLL DOWN
        </button>
      </div>
    </header>
  )
}
